import BellIcon         from "./components/notificationBellIcon";
import NotificationMenu from "./components/notificationLayoutMenu";
import QRMenu           from "./components/qrMenuModal";
import useStyles        from "_styles/organisms/notificationTab";

const component = props => {
	const {
		notificationCount,
		handleClick,
		handleClose,
		anchorEl,
		open,
		isNotificationsPage,
		notificationQRPopup
	} = props;

	const { classes } = useStyles ( undefined, { name: "styles" } );

	return (
		<div className = { classes.notificationTab }>
			{/* <div onClick = { handleClick }>
				<BellIcon
					handleClick       = { handleClick }
					notificationCount = { notificationCount }
					open              = { open }
				/>
			</div> */}

			{
				!isNotificationsPage && (
					<NotificationMenu
						anchorEl        = { anchorEl }
						handleClick     = { handleClick }
						handleClose     = { handleClose }
						notificationCount = { notificationCount }
						open            = { open }
					/>
				)
			}

			{
				notificationQRPopup ?
					<QRMenu notificationQRPopup = { notificationQRPopup } />
					: null
			}
		</div>
	);
};

export default component;
